module.exports = __webpack_public_path__ + "img/about.65937f3f.png";